import * as z from 'zod/v4';

import { type EventId, eventIdSchema } from './EventId.js';
import { type ParticipantPlayType, participantPlayTypeEnum } from './Participant.js';

export type BettingEventId = `${EventId}_${ParticipantPlayType}`;

/**
 * Return a BettingEventId type.
 *
 * @param eventId Event id for bet event
 * @param participantPlayType Participant play type for bet event
 * @returns BetEvent id type
 */
export function getBettingEventId(eventId: EventId, participantPlayType: ParticipantPlayType): BettingEventId {
  return `${eventId}_${participantPlayType}`;
}

/**
 * Zod schema for BettingEventId
 */
export const bettingEventIdSchema = z.custom<BettingEventId>((value) => {
  if (typeof value !== 'string') {
    return false;
  }

  const [eventId, participantPlayType, ...rest] = value.split('_');

  if (rest.length > 0) {
    return false;
  }

  try {
    eventIdSchema.parse(eventId);
    participantPlayTypeEnum.parse(participantPlayType);
  } catch {
    return false;
  }

  return true;
});
